module.exports = __webpack_public_path__ + "assets/img/about-phone-1.650803b1.png";